import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {BaseComponent, FilterModel, LeModalService, Page} from "common-shared";
import {map, takeUntil} from "rxjs/operators";
import {FilterMatchMode, FilterOperator} from "primeng/api";
import {EventFilterModel, EventModel, EventService} from "../../events/event-list/event.service";
import {EventViewModalComponent} from "../../events/event-view/event-view-modal.component";

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styles: [
  ]
})
export class EventsComponent extends BaseComponent implements OnInit {
  @Input() title: string = 'Sync log';
  events$: Observable<EventModel[]>;
  showOnlyErrors: boolean = false;
  filter$ = new BehaviorSubject<FilterModel<EventFilterModel>>(new FilterModel<EventFilterModel>({Filters: {}, Page: new Page({Size: 10})}));

  constructor(private eventService: EventService, private leModalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
    this.filter$.pipe(takeUntil(this.componentDestroyed)).subscribe(filter => {
      this.events$ = this.eventService.getByFilter(filter).pipe(map(pagedData => {
        return pagedData.Data;
      }));
    });
  }

  open(id: string) {
    this.eventService.loadOne(id).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.leModalService.show(EventViewModalComponent, {initialState: {event: value}, class: 'modal-lg'});
    });
  }

  filterErrors() {
    this.showOnlyErrors = !this.showOnlyErrors;
    const filter = this.filter$.getValue();
    filter.Filters = this.showOnlyErrors
      ? {'Level': [
          {matchMode: FilterMatchMode.EQUALS, operator: FilterOperator.OR, value: 0},
          {matchMode: FilterMatchMode.EQUALS, operator: FilterOperator.OR, value: 1},
        ]}
      : {};
    this.filter$.next(filter);
  }
}
